import { KairoLogo } from "@/components/navigation/kairo-logo";
import { Button } from "@/components/ui/button";
import { validateAuthSearch } from "@/features/auth/auth-search";
import { Link, useLocation, useSearch } from "@tanstack/react-router";

export const PublicHeader = () => {
  const location = useLocation();
  const isOnLogin = location.pathname === "/login";
  const isOnSignUp = location.pathname === "/signup";

  // The invite code and CR-288's return-to follow the visitor between
  // Log in and Sign up, so a new user from a deep link still comes back to it.
  const authSearch = validateAuthSearch(useSearch({ strict: false }));
  const forwardedSearch = Object.keys(authSearch).length > 0 ? authSearch : undefined;

  return (
    <header className="bg-white shadow-sm">
      <div className="container mx-auto flex h-16 items-center justify-between px-4">
        <div className="flex items-center">
          <Link to="/">
            <KairoLogo />
          </Link>
        </div>
        <div className="flex items-center gap-4">
          {!isOnLogin && (
            <Link
              to="/login"
              search={forwardedSearch}
              className="hover:text-primary [&.active]:text-primary text-sm font-medium"
            >
              <Button>Log in</Button>
            </Link>
          )}
          {!isOnSignUp && (
            <Link
              to="/signup"
              search={forwardedSearch}
              className="hover:text-primary [&.active]:text-primary text-sm font-medium"
            >
              <Button>Sign up</Button>
            </Link>
          )}
        </div>
      </div>
    </header>
  );
};
